import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type Organisation from "./Organisation";

@Model()
class Tag extends ApplicationRecord {
  static jsonapiType = "tags";

  @Attr() color: string;

  @Attr() label: string;

  @BelongsTo() organisation: Organisation;

  @Attr() organisationId: number;

  @Attr() organisationTeamId: number;

  @BelongsTo() taggable: any;

  @Attr() taggableId: number;

  @Attr() taggableType: string;
}

export default Tag;
